/**
 * Project: Aniatek
 * Author: Carlos A. Loaiza | Connect & Launch
 * Tel: +52 (667) 247 - 6316
 * Intellectual Property: All rights reserved (c) 2026
 */
 
 <template>
    <LoadScreen v-if="mostrarLoader"></LoadScreen>
    <ModalExito v-if="mostrarExito" :mostrarExito="mostrarExito"></ModalExito>
    <ModalError v-if="mostrarError" :mostrarError="mostrarError"></ModalError>
    <ModalBase v-if="mostrarModal">
        <section class="contenedorPrincipal">
            <section>
                <div class="titulo">{{ tituloHeader }}</div>
                <div class="separador"></div>
            </section>
            <div>
                <div class="label">Nombre de la ferretería:</div>
                <input class="inputEditar" type="text" maxlength="20" name="" id="" v-model="nombreFerreteria"
                    placeholder="Ingrese el nombre de la ferretería" />
            </div>
            <div>
                <div class="label">Selecciona un estado:</div>
                <div>
                    <select class="buscadorSelect" id="estado" name="estado" required v-model="estadoSeleccionado"
                        @change="llenarCiudades">
                        <option value="">-- Seleccione uno --</option>
                        <option value="AGS">Aguascalientes</option>
                        <option value="BC">Baja California</option>
                        <option value="BCS">Baja California Sur</option>
                        <option value="CAM">Campeche</option>
                        <option value="CHP">Chiapas</option>
                        <option value="CHH">Chihuahua</option>
                        <option value="CDMX">Ciudad de México</option>
                        <option value="COA">Coahuila</option>
                        <option value="COL">Colima</option>
                        <option value="DUR">Durango</option>
                        <option value="MEX">Estado de México</option>
                        <option value="GTO">Guanajuato</option>
                        <option value="GRO">Guerrero</option>
                        <option value="HGO">Hidalgo</option>
                        <option value="JAL">Jalisco</option>
                        <option value="MCH">Michoacán</option>
                        <option value="MOR">Morelos</option>
                        <option value="NAY">Nayarit</option>
                        <option value="NL">Nuevo León</option>
                        <option value="OAX">Oaxaca</option>
                        <option value="PUE">Puebla</option>
                        <option value="QRO">Querétaro</option>
                        <option value="QR">Quintana Roo</option>
                        <option value="SLP">San Luis Potosí</option>
                        <option value="SIN">Sinaloa</option>
                        <option value="SON">Sonora</option>
                        <option value="TAB">Tabasco</option>
                        <option value="TAM">Tamaulipas</option>
                        <option value="TLX">Tlaxcala</option>
                        <option value="VER">Veracruz</option>
                        <option value="YUC">Yucatán</option>
                        <option value="ZAC">Zacatecas</option>
                    </select>
                </div>
            </div>
            <div>
                <div class="label">Selecciona una ciudad:</div>
                <div>
                    <select class="buscadorSelect" id="ciudad" name="ciudad" required v-model="ciudadSeleccionada"
                        :disabled="!ciudadesDisponibles.length">
                        <option value="">-- Selecciona una ciudad --</option>
                        <option v-for="ciudad in ciudadesDisponibles" :key="ciudad" :value="ciudad">
                            {{ ciudad }}
                        </option>
                    </select>
                </div>
            </div>
            <div>
                <div class="label">Domicilio:</div>
                <input class="inputEditar" type="text" maxlength="20" name="" id="" v-model="nombre"
                    placeholder="Ingrese el domicilio de la ferretería" />
            </div>
            <div>
                <div class="label">Correo:</div>
                <input class="inputEditar" type="text" maxlength="40" name="" id="" v-model="correo"
                    placeholder="Ingrese un correo electrónico" />
            </div>
            <div>
                <div class="label">Teléfono:</div>
                <input class="inputEditar" type="text" maxlength="40" name="" id="" v-model="telefono"
                    placeholder="Ingrese un teléfono de contacto" />
            </div>
            <section class="contenedorBotones">
                <Button class="btn-regresar" @click="cancelar">Regresar</Button>
                <Button class="btn-guardar" @click="registrarAdministrador">Guardar</Button>
            </section>
        </section>
    </ModalBase>
</template>

<script>
import Button from "../Forms/Button.vue";
import ModalBase from "../Modales/ModalBase.vue";
import axios from 'axios';
import ModalExito from "../Modales/ModalExito.vue";
import ModalError from "../Modales/ModalError.vue";
import LoadScreen from '../Forms/LoadScreen.vue';

const CIUDADES_POR_ESTADO = {
    "AGS": ["Aguascalientes", "Asientos", "Calvillo", "Cosío", "Jesús María", "Pabellón de Arteaga", "Rincón de Romos", "San Francisco de los Romo", "San José de Gracia", "Tepezalá", "El Llano"],
    "BC": ["Mexicali", "Tijuana", "Ensenada", "Playas de Rosarito", "Tecate", "San Quintín", "San Felipe"],
    "BCS": ["La Paz", "Los Cabos", "Comondú", "Mulegé", "Loreto"],
    "CAM": ["Campeche", "Carmen", "Champotón", "Escárcega", "Hecelchakán", "Calkiní", "Calakmul", "Hopelchén", "Palizada", "Tenabo", "Dzitbalché"],
    "CHP": ["Tuxtla Gutiérrez", "Tapachula", "San Cristóbal de las Casas", "Comitán de Domínguez", "Chiapilla", "Ocozocuautla de Espinosa", "Palenque", "Reforma", "Tonalá"],
    "CHH": ["Chihuahua", "Ciudad Juárez", "Cuauhtémoc", "Delicias", "Hidalgo del Parral", "Nuevo Casas Grandes", "Guachochi", "Camargo", "Jiménez", "Ojinaga"],
    "CDMX": ["Álvaro Obregón", "Azcapotzalco", "Benito Juárez", "Coyoacán", "Cuajimalpa de Morelos", "Cuauhtémoc", "Gustavo A. Madero", "Iztacalco", "Iztapalapa", "Magdalena Contreras", "Miguel Hidalgo", "Milpa Alta", "Tláhuac", "Tlalpan", "Venustiano Carranza", "Xochimilco"],
    "COA": ["Saltillo", "Torreón", "Monclova", "Ramos Arizpe", "Piedras Negras", "Acuña", "Frontera", "Sabinas"],
    "COL": ["Colima", "Manzanillo", "Villa de Álvarez", "Tecomán", "Armería", "Comala", "Coquimatlán", "Cuauhtémoc", "Ixtlahuacán", "Minatitlán"],
    "DUR": ["Durango", "Gómez Palacio", "Lerdo", "Canatlán", "Guadalupe Victoria", "Santiago Papasquiaro", "El Salto", "Ciudad Lerdo"],
    "MEX": ["Toluca", "Naucalpan de Juárez", "Ecatepec de Morelos", "Nezahualcóyotl", "Tlalnepantla de Baz", "Cuautitlán Izcalli", "Huixquilucan", "Metepec", "Valle de Bravo"],
    "GTO": ["León", "Guanajuato", "Irapuato", "Celaya", "Salamanca", "Silao", "San Miguel de Allende", "Acámbaro", "San Luis de la Paz"],
    "GRO": ["Chilpancingo de los Bravo", "Acapulco de Juárez", "Iguala de la Independencia", "Zihuatanejo de Azueta", "Chilapa de Álvarez", "Taxco de Alarcón", "Tierra Colorada"],
    "HGO": ["Pachuca de Soto", "Tulancingo de Bravo", "Tula de Allende", "Huejutla de Reyes", "Ixmiquilpan", "Actopan", "Apan"],
    "JAL": ["Guadalajara", "Zapopan", "Tlaquepaque", "Puerto Vallarta", "Tonalá", "Tlajomulco de Zúñiga", "Ciudad Guzmán", "Lagos de Moreno", "Autlán de Navarro"],
    "MCH": ["Morelia", "Uruapan", "Zamora", "Apatzingán", "La Piedad", "Zitácuaro", "Lázaro Cárdenas"],
    "MOR": ["Cuernavaca", "Jiutepec", "Cuautla", "Temixco", "Yautepec", "Jojutla", "Puente de Ixtla", "Xochitepec"],
    "NAY": ["Tepic", "Bahía de Banderas", "Santiago Ixcuintla", "Compostela", "Ixtlán del Río", "San Blas", "Acaponeta"],
    "NL": ["Monterrey", "San Nicolás de los Garza", "Guadalupe", "Apodaca", "San Pedro Garza García", "Santa Catarina", "García", "Escobedo", "Juárez", "Cadereyta Jiménez"],
    "OAX": ["Oaxaca de Juárez", "San Juan Bautista Tuxtepec", "Salina Cruz", "Juchitán de Zaragoza", "Huajuapan de León", "Puerto Escondido", "Heroica Ciudad de Huajuapan de León", "Miahuatlán de Porfirio Díaz"],
    "PUE": ["Puebla", "Tehuacán", "Atlixco", "San Martín Texmelucan", "Amozoc", "Cholula", "Zacatlán", "Teziutlán"],
    "QRO": ["Querétaro", "San Juan del Río", "Corregidora", "El Marqués", "Amealco de Bonfil", "Cadereyta de Montes", "Jalpan de Serra"],
    "QR": ["Cancún", "Chetumal", "Playa del Carmen", "Cozumel", "Isla Mujeres", "Felipe Carrillo Puerto", "Tulum", "Bacalar"],
    "SLP": ["San Luis Potosí", "Soledad de Graciano Sánchez", "Matehuala", "Ciudad Valles", "Tamazunchale", "Rioverde", "Ébano"],
    "SIN": [
        "Culiacán", "Mazatlán", "Ahome", "Guasave", "Salvador Alvarado", "Navolato",
        "El Fuerte", "Sinaloa", "Escuinapa", "Rosario", "Angostura",
        "Mocorito", "Badiraguato", "Choix", "San Ignacio", "Concordia",
        "Cosalá", "Elota"
    ],
    "SON": ["Hermosillo", "Ciudad Obregón", "Nogales", "San Luis Río Colorado", "Guaymas", "Navojoa", "Agua Prieta", "Caborca", "Huatabampo"],
    "TAB": ["Centro (Villahermosa)", "Cárdenas", "Comalcalco", "Macuspana", "Tenosique", "Huimanguillo", "Paraíso", "Nacajuca"],
    "TAM": ["Ciudad Victoria", "Tampico", "Reynosa", "Matamoros", "Nuevo Laredo", "Mante", "Altamira", "Río Bravo"],
    "TLX": ["Tlaxcala", "Apizaco", "Huamantla", "Zacatelco", "Calpulalpan", "Chiautempan", "San Pablo del Monte"],
    "VER": ["Veracruz", "Xalapa", "Coatzacoalcos", "Córdoba", "Boca del Río", "Orizaba", "Poza Rica", "Tuxpan", "Minatitlán"],
    "YUC": ["Mérida", "Kanasín", "Valladolid", "Tizimín", "Progreso", "Umán", "Tekax", "Motul"],
    "ZAC": ["Zacatecas", "Fresnillo", "Guadalupe", "Jerez", "Río Grande", "Sombrerete", "Jalpa"]
};

export default {
    components: {
        Button,
        ModalBase,
        ModalExito,
        ModalError,
        LoadScreen,
    },
    props: {
        tituloHeader: {
            type: String,
            default: "Agregar Ferretería",
        },
    },
    data() {
        return {
            estadoSeleccionado: '',
            ciudadSeleccionada: '',
            ciudadesDisponibles: [],
            showAddProducto: false,
            mostrarLoader: false,
            mostrarModal: true,
            mostrarExito: false,
            mostrarError: false,
            nombreFerreteria: '',
            nombre: '',
            apellidoPaterno: '',
            apellidoMaterno: '',
            correo: '',
            clave: '',
            rol: 'Administrador',
        };
    },
    emits: ["cancelar"],
    methods: {
        llenarCiudades() {
            this.ciudadSeleccionada = '';

            const estado = this.estadoSeleccionado;
            if (!estado) {
                this.ciudadesDisponibles = [];
                return;
            }

            const ciudades = CIUDADES_POR_ESTADO[estado] || [];

            this.ciudadesDisponibles = ciudades;
        },

        mostrarAddService() {
            this.showAddProducto = true;
        },
        ocultarAddProd() {
            this.showAddProducto = false;
        },
        cancelar() {
            this.$emit("cancelar");
        },
        registrarAdministrador() {
            this.mostrarModal = false;

            if (!this.nombreFerreteria || !this.estadoSeleccionado || !this.ciudadSeleccionada || !this.nombre) {
                this.mostrarError = true;
                return;
            }

            this.mostrarLoader = true;

            const adminData = {
                nombreFerreteria: this.nombreFerreteria,
                estado: this.estadoSeleccionado, 
                ciudad: this.ciudadSeleccionada, 
                nombre: this.nombre,
                apellidoPaterno: this.apellidoPaterno || null,
                apellidoMaterno: this.apellidoMaterno || null,
                rol: this.rol,
                correo: this.correo,
                clave: this.clave,
            };

            axios.post('http://localhost:3000/api/usuarios_admin', adminData)
                .then(response => {
                    console.log('Administrador agregado con éxito', response);
                    setTimeout(() => {
                        this.mostrarLoader = false;
                        this.mostrarExito = true;

                        // Limpiar los campos
                        this.nombreFerreteria = '';
                        this.nombre = '';
                        this.apellidoPaterno = '';
                        this.apellidoMaterno = '';
                        this.correo = '';
                        this.clave = '';
                        this.estadoSeleccionado = '';
                        this.ciudadSeleccionada = '';
                        this.ciudadesDisponibles = [];

                        this.mostrarModal = false;

                        setTimeout(() => {
                            this.mostrarExito = false;
                            window.location.reload();
                        }, 2000);
                    }, 1500);
                })
                .catch(error => {
                    console.error('Error al agregar el administrador:', error);
                    this.mostrarLoader = false;
                    this.mostrarError = true;
                });
        },
    },
    mounted() {
        this.ciudadesDisponibles = [];
    }
};
</script>

<style scoped>
.titulo {
    padding: 30px 0px 0px 0px;
    font-size: 30px;
}

.separador {
    border-top: 3px solid #2a428c;
    height: 2px;
    max-width: 100%;
    padding: 0;
    margin-top: 5px;
    margin-bottom: 30px;
}

.contenedorPrincipal {
    margin: 0px 30px;
}

.label {
    margin: 17px 0px 5px;
}

.inputEditar {
    width: 300px;
    height: 32px;
    border: 0px solid #000000;
    box-shadow: 0px 3px 6px #00000029;
    outline: none;
    color: #000000;
    padding: 0px 7px;
    border-radius: 10px;
}

.buscadorSelect {
    width: 100%;
    height: 32px;
    border: 0px solid #000000;
    box-shadow: 0px 3px 6px #00000029;
    outline: none;
    padding: 0px 7px;
    border-radius: 10px;
}

.contenedorBotones {
    display: flex;
    justify-content: space-between;
    max-width: 80%;
    margin: auto;
    padding: 30px 0px 20px;
}
</style>